// change-bus.js — bus de cambios per-tabla: lo que hace que la UI sea reactiva sobre SQLite.
//
// SQLite no auto-observa tablas: una query no se re-ejecuta sola cuando alguien escribe. Este bus lo
// suple:
// las rutas de ESCRITURA del StorageAdapter disparan notify*(tabla) DESPUES de commit, y los
// consumidores (useReactiveQuery) se suscriben por nombre de tabla para re-consultar.
//
// CAPA UNICA DE EMISION (Pitfall 4: double-emit): SOLO StorageAdapter llama notify/notifyMany;
// SOLO useReactiveQuery llama subscribe. Cero emits en repos/sync/domain/.vue. Un grep de
// `notify(`/`notifyMany` en src/offline-v2 debe salir unicamente aqui y en StorageAdapter.js.
//
// Modulo PURO: cero imports. Singleton de modulo (Map de tabla -> Set<fn>).

const listeners = new Map() // tableName -> Set<fn>

/** Dispara los callbacks suscritos a `table`. No-op si no hay suscriptores. */
export function notify (table) {
  const set = listeners.get(table)
  if (set) for (const fn of set) fn(table)
}

/**
 * Dispara notify por cada tabla de `tables` (array o cualquier iterable, p.ej. un Set).
 * La de-dup es responsabilidad del llamador (StorageAdapter pasa un Set / array unico).
 */
export function notifyMany (tables) {
  if (!tables) return
  for (const t of tables) notify(t)
}

/**
 * Suscribe `cb` a una o varias tablas. `tables` se normaliza a array.
 * @returns {function} unsubscribe() — quita cb de TODAS sus tablas.
 */
export function subscribe (tables, cb) {
  const list = Array.isArray(tables) ? tables : [tables]
  for (const t of list) {
    if (!listeners.has(t)) listeners.set(t, new Set())
    listeners.get(t).add(cb)
  }
  return () => {
    for (const t of list) listeners.get(t)?.delete(cb)
  }
}

/** SOLO para tests: limpia el registry entre casos (beforeEach). No usar en produccion. */
export function _clearListeners () {
  listeners.clear()
}
